import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { canShowMandatoryGate } from '@frontend/web/components/SignInGate/displayRule';
import { initPerf } from '@root/src/web/browser/initPerf';
const SignInGateMandatory = React.lazy(() => {
    const { start, end } = initPerf('SignInGateMain');
    start();
    return import(
    /* webpackChunkName: "SignInGateMain" */ '../gateDesigns/SignInGateMandatory').then((module) => {
        end();
        return { default: module.SignInGateMandatory };
    });
});
export const signInGateComponent = {
    gate: ({ ophanComponentId, dismissGate, // TODO if this becomes the winner we can remove the unused dismissGate
    guUrl, signInUrl, abTest, isComment, }) => (React.createElement(Lazy, { margin: 300 },
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement(SignInGateMandatory, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment })))),
    canShow: canShowMandatoryGate,
};
